/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-shadow-show-inner',
  templateUrl: './theme-option-elements-chart-gauge-shadow-show-inner.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-shadow-show-inner.component.css']
})
export class ThemeOptionElementsChartGaugeShadowShowInnerComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_shadow_show_inner';
  showDetails: boolean;

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption(this.optionType, value);
  }

}